import React from "react";
import "./Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Footer = () => {
  const navigate = useNavigate()
  const {userId} = useSelector(state=>state.userReducer)
  return (
    <footer className={`footer ${userId ? 'authenticated' : 'unauthenticated'}`}>
      <div className="footer-container">
        <div className="footer-section about">
          <h3 style={{textAlign:"left"}}>About</h3>
          <p style={{textAlign:"left"}}>
           Corporate NRIs is more than just a service platform; it’s a vibrant community built for NRIs, by NRIs. Founded with a vision to empower working professionals, families, students, and retirees living abroad, we provide a centralized hub where you can access verified services, share resources, and connect with others who understand your journey. Whether you're relocating, traveling, or seeking local support, we’re here to make your experience effortless and reliable.
          </p>
          <div className="social-icons" style={{justifyContent:"left"}}>
            <a href="https://www.facebook.com/share/1BBPGw7gKV/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/corporate-nri/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/corporatenri?igsh=MWc2dDVzeTNpMW9yaQ==" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>

        <div className="footer-section links">
          <h3>Quick Link</h3>
          <ul>
            <li><button onClick={()=>{navigate(userId?"/home":"/")}} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}>Home</button></li>
            <li><button onClick={()=>{navigate("/about")}} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}>About</button></li>
            <li><button onClick={()=>{navigate("/services")}} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}>Service</button></li>
            <li><button onClick={()=>{navigate("/faq")}} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}>FAQ</button></li>
            <li><button onClick={()=>{navigate("/contact")}} style={{background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit'}}>Contact</button></li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h3 style={{textAlign:"left"}}>Contact</h3>
          <p style={{textAlign:"left"}}><MdLocationOn className="icon" />Madhapur, Hyderabad, Telangana, 500082<br /></p>
          <p><MdEmail className="icon" /> support@corporatenri.com</p>
          {/* <p><MdPhone className="icon" /> +91 9494939578</p> */}
        </div>
      </div>
      <div className="footer-bottom">
        © COPYRIGHT 2026 CorporateNRI ALL RIGHTS RESERVED.
      </div>
    </footer>
  );
};

export default Footer;
